import React from "react";
import { Outlet } from "react-router-dom";

const BillingParentPage = () => {
  return <Outlet />;
};

export default BillingParentPage;
